export default __webpack_public_path__ + "static/media/free-medical.588ed667.png";